import React, { useContext, useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import { fontWeight } from '@mui/system';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import PaginaProduto from './../Pages/PaginaProduto/PaginaProduto';
import ModalDetalhes from '../../components/Pages/PaginaProduto/ModalDetalhes';
import { MyContext } from '../../context/MyContext';

function CarrosselMini(retornoApiSimultaneos) {
    const [localizados, setLocalizados] = useState([]);
    const [produtoSelecionado, setProdutoSelecionado] = useState([]);    
    const { codigoReload, setCodigoReload } = useContext(MyContext);
    const { setOpenMD } = useContext(MyContext);
    const [ codigoClicado, setCodigoClicado] = useState(null);
    setCodigoReload(produtoSelecionado.codigo);    
        
    const handleClick = (item) => {
        setCodigoReload(item.codigo);
        abrirPaginaModalDetalhes(item.codigo);
    };

    const abrirPaginaModalDetalhes = (e) => {
        const filteredProduct = retornoApiSimultaneos.props.produtos.filter(product => product.codigo === e);
        setCodigoClicado(filteredProduct[0]);        
        setOpenMD(true);            
    };

    return (
        <>            
            <Swiper
                // className="sample-slider"
                modules={[Navigation, Pagination, Autoplay]}
                navigation
                pagination
                autoplay={{ delay: 1, autoplay: true }}
                loop={true}
                speed={4000}
                spaceBetween={retornoApiSimultaneos.espacamento}
                slidesPerView={retornoApiSimultaneos.itensPorPaginaView}
                centeredSlides
                slideShadows={true}
                allowSlideNext={true}
                allowSlidePrev={true}
                paddingTop={'30px'}
                initialSlide={1}
                onClick={(swiper) => console.log(swiper.activeIndex)}
                style={{
                    "--swiper-pagination-color": "#58d68d",
                    "--swiper-pagination-bullet-inactive-color": "#999999",
                    "--swiper-pagination-bullet-inactive-opacity": "1",
                    "--swiper-pagination-bullet-size": "10px",
                    "--swiper-pagination-bullet-margin-top": "40px",
                    "--swiper-pagination-bullet-horizontal-gap": "6px",
                    "--swiper-navigation-color": "#82e0aa",
                }}
            >
                {
                    retornoApiSimultaneos?.props?.produtos?.map((prod) => {
                        return (
                            <SwiperSlide key={prod?.codigo} onClick={() => handleClick(prod)}>
                                <div style={{ margin: '5%', marginBottom: '8px' }}>
                                    <Card sx={{ width: "170px", maxWidth: "170px", minWidth: "170px", minHeight: "240px", maxHeight: "240px" }}>
                                        <CardContent>
                                            <div style={{ justifyContent: "center", display: "flex" }}><img src={prod.caminho_imagem} alt={prod.descricao} style={{ listStyle: "none", borderTopLeftRadius: "5px", borderTopRightRadius: "5px", width: 'null', height: '130px', maxHeight: '130px', display: 'block', objectFit: 'cover' }} /></div>
                                            <Typography fontSize={"11px"} textAlign={"left"} gutterBottom>
                                                {prod?.descricao}
                                            </Typography>
                                            <Typography fontSize={"12px"} textAlign={"left"} fontWeight={"Bold"} marginTop={"-6px"} component="div">
                                            <span style={{ color: "red" }}> {prod.a_vista.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} </span>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; {prod?.id_marcaNavigation?.descricao}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </div>
                            </SwiperSlide>
                        );
                    })
                }
            </Swiper>

            {
                (
                    codigoClicado == null 
                    ?
                    <></>
                    :
                    <ModalDetalhes props={codigoClicado} />
                )
            }          

        </>
    )
}
export default CarrosselMini;